import TextEditingPanel from './TextEditingPanelContainer';

export default TextEditingPanel;
